export const INITIAL_STATE = {
    window: "Customer",
    showWindowPicker:true
};


// WEBPACK FOOTER //
// ./src/reducers/state/Page.js